import React from 'react';
import CardWithBorder from "../components/card/CardWithBorder";
import "../style/privacy-policy.scss"
import DivLanguage from "../components/DivLanguage";

const PrivacyPolicy = (props) => {

    return (
        <>
            <section className="privacy-policy-top-section wave-section">
                <DivLanguage language="fr" className="center">
                    <div className="title">
                        <h1>Politique de confidentialité</h1>
                        <p className="subtitle">Cette politique de confidentialité vous informe sur la manière dont nous collectons et utilisons vos données éventuellement collectées sur ce site internet, ainsi que sur vos droits en application du Règlement Général sur la Protection des Données (RGPD).</p>
                    </div>
                </DivLanguage>
                <DivLanguage language="en" className="center">
                    <div className="title">
                        <h1>Privacy Policy</h1>
                        <p className="subtitle">
                            This privacy policy informs you about how we collect and use any data that may be collected on this website, as well as your rights under the General Data Protection Regulation (GDPR).
                        </p>
                    </div>
                </DivLanguage>



            </section>

            <section className="privacy-policy-sec2 wave-section">
                <DivLanguage language="fr" className="center">
                    <h2>Identité du responsable de traitement</h2>
                    <p className="p18-medium">
                        Le responsable de traitement est : <br/>
                        <span className="span-blue">ALPHAWAVE</span>
                    </p>
                    <p className="p18-medium">
                        ALPHAWAVE – 38 Rue des Bourdonnais,
                        75001, Paris – FRANCE
                    </p>
                    <p className="p18-medium">
                        Email : dataprivacy@alphawave.fr
                    </p>
                    <p className="p18-medium">
                        Pour toute question relative à vos données personnelles, vous pouvez également contacter notre Délégué à la Protection des Données (DPO) à l’adresse ci-dessus.
                    </p>
                </DivLanguage>
                <DivLanguage language="en" className="center">
                    <h2>Identity of the data controller</h2>
                    <p className="p18-medium">
                        The data controller is: <br/>
                        <span className="span-blue">ALPHAWAVE</span>
                    </p>

                    <p className="p18-medium">
                        ALPHAWAVE – 38 Rue des Bourdonnais,
                        75001, Paris – FRANCE
                    </p>

                    <p className="p18-medium">
                        Email: dataprivacy@alphawave.fr
                    </p>

                    <p className="p18-medium">
                        For any questions regarding your personal data, you may also contact our Data Protection Officer (DPO) at the address above.
                    </p>
                </DivLanguage>
            </section>

            <section className="privacy-policy-sec3">
                <DivLanguage language="fr" className="center">
                    <h2>Données et finalités</h2>

                    <div className="wrapper-tiers">

                        <CardWithBorder title="Formulaires de contact" icon="fa-solid fa-envelope">
                            <p className="p18-regular">
                                Lorsque vous remplissez un formulaire de contact sur notre site, nous collectons :
                            </p>
                            <ul>
                                <li>Votre nom</li>
                                <li>Votre adresse email</li>
                                <li>Le sujet et le contenu de votre message</li>
                            </ul>
                        </CardWithBorder>

                        <CardWithBorder title="Documents téléchargeables" icon="fa-solid fa-file-arrow-down">
                            <p className="p18-regular">
                                Lorsque vous téléchargez des documents sur notre site, nous collectons :
                            </p>
                            <ul>
                                <li>Votre adresse email</li>
                                <li>L’adresse IP utilisée pour accéder au lien de téléchargement</li>
                            </ul>
                        </CardWithBorder>

                        <CardWithBorder title="Utilisation des données" icon="fa-solid fa-database">
                            <p className="p18-regular">
                                Ces données sont utilisées pour répondre à vos demandes et pour des actions de prospection commerciale B2B.
                            </p>
                            <p className="p18-regular">
                                Vous pouvez à tout moment vous opposer à cette prospection en cliquant sur le lien de désinscription dans les emails ou en écrivant à :
                                <span className="span-blue"> dataprivacy@alphawave.fr</span>
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Durée de conservation" icon="fa-solid fa-clock">
                            <p className="p18-regular">
                                Vos données personnelles sont conservées pour une durée maximale de trois ans à compter de leur collecte ou du dernier contact de votre part.
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Destinataires des données" icon="fa-solid fa-share-nodes">
                            <p className="p18-regular">
                                Vos données personnelles sont exclusivement utilisées par ALPHAWAVE et ne sont jamais vendues à des tiers.
                            </p>
                            <p className="p18-regular">
                                Elles peuvent être partagées avec nos prestataires techniques pour la gestion de nos outils de prospection. Aucune donnée n’est transférée hors de l’Union européenne.
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Cookies" icon="fa-solid fa-cookie-bite">
                            <p className="p18-regular">
                                Nous n’utilisons aucun cookie sur ce site. Votre navigation est totalement anonyme.
                            </p>
                        </CardWithBorder>

                    </div>
                </DivLanguage>

                <DivLanguage language="en" className="center">
                    <h2>Data and Purposes</h2>

                    <div className="wrapper-tiers">

                        <CardWithBorder title="Contact Forms" icon="fa-solid fa-envelope">
                            <p className="p18-regular">
                                When you fill out a contact form on our website, we collect:
                            </p>
                            <ul>
                                <li>Your name</li>
                                <li>Your email address</li>
                                <li>The subject and content of your message</li>
                            </ul>
                        </CardWithBorder>

                        <CardWithBorder title="Downloadable Documents" icon="fa-solid fa-file-arrow-down">
                            <p className="p18-regular">
                                When you download documents from our website, we collect:
                            </p>
                            <ul>
                                <li>Your email address</li>
                                <li>The IP address used to access the download link</li>
                            </ul>
                        </CardWithBorder>

                        <CardWithBorder title="Use of Data" icon="fa-solid fa-database">
                            <p className="p18-regular">
                                This data is used to respond to your requests and for B2B commercial prospecting activities.
                            </p>
                            <p className="p18-regular">
                                You may object to this prospecting at any time by clicking the unsubscribe link in our emails or by writing to:
                                <span className="span-blue"> dataprivacy@alphawave.fr</span>
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Data Retention Period" icon="fa-solid fa-clock">
                            <p className="p18-regular">
                                Your personal data is retained for a maximum period of three years from the date of collection or the last contact from you.
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Data Recipients" icon="fa-solid fa-share-nodes">
                            <p className="p18-regular">
                                Your personal data is used exclusively by ALPHAWAVE and is never sold to third parties.
                            </p>
                            <p className="p18-regular">
                                It may be shared with our technical service providers for the management of our prospecting tools. No data is transferred outside the European Union.
                            </p>
                        </CardWithBorder>

                        <CardWithBorder title="Cookies" icon="fa-solid fa-cookie-bite">
                            <p className="p18-regular">
                                We do not use any cookies on this website. Your browsing remains completely anonymous.
                            </p>
                        </CardWithBorder>

                    </div>
                </DivLanguage>
            </section>


            <section className="privacy-policy-sec4 wave-section">
                <DivLanguage language="fr" className="bg-white">
                    <div className="center">

                        <h2>Base juridique du traitement</h2>
                        <p className="p18-medium">
                            Le traitement de vos données repose sur notre intérêt légitime à développer nos activités commerciales auprès de professionnels.
                        </p>


                        <h2>Vos droits</h2>
                        <p className="p18-medium">
                            Conformément au RGPD, vous disposez des droits suivants :
                        </p>

                        <ul className="p18-medium">
                            <li>Droit d’accès</li>
                            <li>Droit de rectification</li>
                            <li>Droit d’effacement</li>
                            <li>Droit d’opposition</li>
                            <li>Droit à la limitation du traitement</li>
                        </ul>

                        <p className="p18-medium">
                            Pour exercer vos droits, envoyez un email à
                            <span className="span-blue"> dataprivacy@alphawave.fr</span>.
                        </p>

                        <h2>Réclamation auprès de l’autorité de contrôle</h2>
                        <p className="p18-medium">
                            Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l’Informatique et des Libertés).


                        </p>

                    </div>
                </DivLanguage>

                <DivLanguage language="en" className="bg-white">
                    <div className="center">

                        <h2>Legal Basis</h2>
                        <p className="p18-medium">
                            The processing of your data is based on our legitimate interest in developing our business activities with professionals.
                        </p>

                        <h2>Data Retention</h2>
                        <p className="p18-medium">
                            Your personal data is kept for a maximum period of three years from collection or last contact.
                        </p>

                        <h2>Data Recipients</h2>
                        <p className="p18-medium">
                            Your personal data is used exclusively by ALPHAWAVE and is never sold to third parties. It may be shared with technical service providers for managing our tools. No data is transferred outside the European Union.
                        </p>

                        <h2>Your Rights</h2>
                        <p className="p18-medium">
                            In accordance with GDPR, you have the following rights:
                        </p>

                        <ul className="p18-medium">
                            <li>Right of access</li>
                            <li>Right to rectification</li>
                            <li>Right to erasure</li>
                            <li>Right to object</li>
                            <li>Right to restriction of processing</li>
                        </ul>

                        <p className="p18-medium">
                            To exercise your rights, contact us at
                            <span className="span-blue"> dataprivacy@alphawave.fr</span>.
                        </p>

                        <h2>Complaint</h2>
                        <p className="p18-medium">
                            If you believe your rights are not respected, you may file a complaint with the CNIL.
                        </p>

                    </div>
                </DivLanguage>
            </section>

        </>
    )
};

export default PrivacyPolicy;